import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Benefits } from "@/components/Benefits";
import { Products } from "@/components/Products";
import { Reviews } from "@/components/Reviews";
import { Manifesto } from "@/components/Manifesto";
import { Wholesale } from "@/components/Wholesale";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { Scallop } from "@/components/Scallop";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Scallop bg="#FBF6EC" color="#FF6B00" />
        <Marquee />
        <Benefits />
        <Products />
        <Reviews />
        <Manifesto />
        <Wholesale />
        <Scallop bg="#4A148C" color="#2B0B3C" />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
